import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'EU AI Act Training Platform - KI-Kompetenznachweis',
  description = 'Werden Sie in 45 Minuten compliant mit dem EU AI Act. Online-Schulung mit automatischem Abschlusstest und Zertifikat. Sofort einsatzbereit für nur 49,90 € zzgl. MwSt.',
  keywords = [
    'EU AI Act',
    'KI-Schulung',
    'KI-Kompetenz',
    'AI Zertifikat',
    'Künstliche Intelligenz Schulung',
    'KI-Kompetenznachweis',
    'AI Act Compliance',
    'Online-Kurs KI',
    'KI-Training',
    'Artificial Intelligence Act'
  ],
  canonicalUrl,
  ogType = 'website',
  ogImage = 'https://ki-kompetenznachweis.online/og-image.jpg',
  noIndex = false
}) => {
  const siteUrl = 'https://ki-kompetenznachweis.online';
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  const fullTitle = title.includes('EU AI Act') ? title : `${title} | EU AI Act Training Platform`;

  return (
    <Helmet>
      <html lang="de" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="canonical" href={fullCanonicalUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="EU AI Act Training Platform" />
      <meta property="og:locale" content="de_DE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="author" content="EU AI Act Training Platform" />
      <meta name="copyright" content="EU AI Act Training Platform" />

      <meta name="theme-color" content="#2574B5" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
    </Helmet>
  );
};

export default SEOHead;
